import type { WorkflowRunPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';

/** `201`: the new run, as `GET` renders it. */
export type WorkflowRunOpenedAction = {
	type: 'WORKFLOW_RUN_OPENED';
	payload: WorkflowRunPayload;
	facilityId: number;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: WorkflowRunPayload,
	facilityId: number,
	typeKey: string,
	subjectId: number,
): WorkflowRunOpenedAction => ({
	type: 'WORKFLOW_RUN_OPENED',
	payload,
	facilityId,
	typeKey,
	subjectId,
});
